export const accordion = () => {
    const accordionTogglers = document.getElementsByClassName('toggle');

    for (let i = 0; i < accordionTogglers.length; i++) {
        accordionTogglers[i].children[0].addEventListener('click', function() {
            accordionTogglers[i].children[1].classList.toggle('hidden');
        });
    }
};
